// extracted by mini-css-extract-plugin
export default {"container":"UnfitProfileNotice_container__RIdOE","page":"UnfitProfileNotice_page__9dU4v"};